import { gql } from '@apollo/client'
import { USER_FRAGMENT } from './User'

export const CONFORMITY_HISTORY_STATS_FRAGMENT = gql`
  fragment ConformityHistoryStatsFragment on ConformityHistoryStats {
    moderator {
      ...UserFragment
    }
    treatedCount
  }
  ${USER_FRAGMENT}
`

export const CONFORMITY_HISTORY_STATS_QUERY = gql`
  query conformityHistoryStats($date: ISO8601DateTime!) {
    conformityHistoryStats(date: $date) {
      ...ConformityHistoryStatsFragment
    }
  }
  ${CONFORMITY_HISTORY_STATS_FRAGMENT}
`
